import { Routes } from '@angular/router';

import { semanticCatalogMatcher } from '@app/routing/semantic-catalog-url.matcher';

export const publicSiteChildRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@features/catalog/catalog-list.page').then((m) => m.CatalogListPage),
  },
  {
    matcher: semanticCatalogMatcher,
    loadComponent: () => import('@features/catalog/catalog-list.page').then((m) => m.CatalogListPage),
  },
  {
    path: 'entrar',
    loadComponent: () => import('@features/entrar/entrar.page').then((m) => m.EntrarPage),
  },
  {
    path: 'inicio',
    loadComponent: () => import('@features/home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'navegacao',
    children: [
      {
        path: 'nao-encontrada',
        loadComponent: () => import('@features/not-found/pages/not-found/not-found.component').then((m) => m.NotFoundComponent), data: { publicShellLayout: 'minimal' }
      },
    ],
  },
  {
    path: 'imoveis',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: 'imoveis',
    children: [
      {
        path: ':publicSlug',
        loadComponent: () => import('@features/catalog/property-detail.page').then((m) => m.PropertyDetailPage),
      },
    ],
  },
];
